module.exports = [{"code":"02","label":"Primary"},{"code":"1","label":"Secondary"},{"code":"2","label":"Post-Secondary"},{"code":"3","label":"Graduate Degree"},{"code":"6","label":"Post-Graduate Degree"},{"code":"7","label":"Doctorate"},{"code":"8","label":"Others"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/form/wrongEductions.json
// module id = 1373
// module chunks = 0